


















import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { ProductReference } from '@cstweb/site/types/product/productTypes'
import { filterReferencesForBackground, generateReferenceUrl } from '@/common/utils/product/product'

export default defineComponent({
  props: {
    references: {
      type: Array as () => Array<ProductReference>,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const mappedReferences = props.references ? filterReferencesForBackground(props.references) : []

    return {
      isEmpty,
      mappedReferences,
      generateReferenceUrl,
    }
  },
})
